import { useState, useEffect, useRef } from "react";
import {
  ActivitiesCreateService,
  ActivitiesListService,
  CategoriesListService,
  CategoriesListAllService,
  ActivityGetService,
  ActivityUpdateService,
} from "../services/ActivitiesServices";
import {
  GendersListService,
  SpecialProtectionGroupsListService,
} from "../../participants/services/ParticipantService";
import { NodeListAllService } from "../../node/services/NodeService";
import { UsersForFiltersService } from "../../user/services/UserService";
import { ActivitiesCreate } from "../modules/ActivitiesCreate";
import { ActivitiesEdit } from "../modules/ActivitiesEdit";
import ActivitiesList from "../modules/ActivitiesList";
import Spinner from "components/MDSpinner";
import MDAlert from "components/Alert";
import { bool } from "prop-types";
import FilterController from "components/filter/controller/FilterController";
import data from "layouts/tables/data/authorsTableData";

export default function ActivitiesController() {
  const filterConfig = [
    { visibleName: "Título", dbField: "title", type: "text" },
    { visibleName: "Descripción", dbField: "description", type: "text" },
    { visibleName: "Palabras clave", dbField: "keywords", type: "text" },
    // { visibleName: "Formatos de evidencia", dbField: "evidence_formats", type: "text" },
    {
      visibleName: "Certificable",
      dbField: "is_certifiable",
      type: "select",
      source: "certifiableTypes",
    },
    {
      visibleName: "Subcategoría",
      dbField: "subcategory",
      type: "select",
      source: "subCategoryTypes",
    },
    {
      visibleName: "Categoría",
      dbField: "category",
      type: "select",
      source: "categoryTypes",
    },
    {
      visibleName: "Autor",
      dbField: "author_id",
      type: "select",
      source: "authorTypes",
    },
    {
      visibleName: "Nodo",
      dbField: "node_id",
      type: "select",
      source: "nodeTypes",
    },
    { visibleName: "Fecha de actividad", dbField: "fecha", type: "date" },
    { visibleName: "Documento del participante", dbField: "document", type: "text" },
    { visibleName: "Nombre del participante", dbField: "name", type: "text" },
    { visibleName: "Apellido del participante", dbField: "last_name", type: "text" },
    {
      visibleName: "Género del participante",
      dbField: "gender",
      type: "select",
      source: "genderTypes",
    },
    { visibleName: "Localidad del participante", dbField: "location", type: "text" },
    { visibleName: "Período académico del participante", dbField: "semester", type: "semester" },
    {
      visibleName: "Población vulnerable del participante",
      dbField: "special_protection_group",
      type: "select",
      source: "specialProtectionGroupTypes",
    },

    // { visibleName: "Categorías", dbField: "categories", type: "text" },
  ];

  const dataTable = "activities"; //Tabla indicada
  const filterControllerRef = useRef();
  const [isDisabled, setIsDisabled] = useState(false);
  const [newData, setNewData] = useState({
    title: "",
    timeStart: "",
    timeEnd: "",
    fecha: "",
    description: "",
    keywords: "",
    evidence_formats: "",
    is_certifiable: null,
    categories: "",
    node_id: "",
  });
  const [openCreate, setOpenCreate] = useState(false);
  const [openEdit, setOpenEdit] = useState(false);
  const [editingActivity, setEditingActivity] = useState(null);
  const [editData, setEditData] = useState({
    title: "",
    timeStart: "",
    timeEnd: "",
    fecha: "",
    description: "",
    keywords: "",
    evidence_formats: "",
    is_certifiable: null,
    categories: "",
    node_id: "",
    subcategories: [],
  });
  const [originalEditData, setOriginalEditData] = useState({
    title: "",
    timeStart: "",
    timeEnd: "",
    fecha: "",
    description: "",
    keywords: "",
    evidence_formats: "",
    is_certifiable: null,
    categories: "",
    node_id: "",
    subcategories: [],
  });
  const [selectedSubcategoriesEdit, setSelectedSubcategoriesEdit] = useState([]);
  const [hasChanges, setHasChanges] = useState(false);
  const [isSubmittingEdit, setIsSubmittingEdit] = useState(false);
  const [loading, setLoading] = useState(false);
  const [initialLoading, setInitialLoading] = useState(true);
  const [alert, setAlert] = useState({ visible: false, message: "", type: "" });
  const [handleActivitiesList, setActivitiesList] = useState([]);
  const [totalPages, setTotalPages] = useState(0);
  const [totalData, setTotalData] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const [entriesStart, setEntriesStart] = useState(0);
  const [entriesEnd, setEntriesEnd] = useState(0);
  const [paginaSize, setPaginaSize] = useState(10);
  const [subCategoriesList, setSubCategoriesList] = useState([]);
  const [gendersList, setGendersList] = useState([]);
  const [specialProtectionGroupsList, setSpecialProtectionGroupsList] = useState([]);
  const [nodesList, setNodesList] = useState([]);
  const [usersList, setUsersList] = useState([]);
  const [message, setMessage] = useState("");
  const [isAlert, setIsAlert] = useState(false);
  const [typeAlert, setTypeAlert] = useState("");
  const [isFirstLoad, setIsFirstLoad] = useState(true);

  // Función para llamar a handleClickSubmit desde el componente padre
  const callHandleClickSubmit = (event) => {
    const { dataset } = event.target;
    const exportData = dataset.export;
    if (filterControllerRef.current) {
      filterControllerRef.current.handleClickSubmit(exportData);
    }
  };

  const requestActivitiesList = async (pageIndex, pageSize, vista) => {
    setLoading(true);
    try {
      const result = await ActivitiesListService(pageIndex, pageSize, vista);
      if (result.success) {
        const { payload } = result;
        setActivitiesList(result.payload.data);
        // setTotalPages(result.totalPages || 0);
        // setTotalData(result.totalData || 0);
        await setTotalPages(payload.last_page);
        await setTotalData(payload.total);
        await setEntriesStart(payload.from);
        await setEntriesEnd(payload.to);
      } else {
        handleAlert("error", result.message);
      }
    } catch (error) {
      handleAlert("error", "Error al obtener las actividades");
    } finally {
      setLoading(false);
    }
  };

  const requestSubCategoriesList = async (pageIndex) => {
    setLoading(true);
    try {
      // Intentar primero con el endpoint sin permisos
      let result = await CategoriesListAllService();

      // Si falla o no existe el endpoint /all/, usar el servicio original
      if (!result.success) {
        result = await CategoriesListService(pageIndex);
      }

      if (result.success) {
        setSubCategoriesList(result.payload);
      } else {
        handleAlert("error", result.message);
      }
    } catch (error) {
      handleAlert("error", "Error al obtener las categorías");
    } finally {
      setLoading(false);
    }
  };

  const requestNodesList = async () => {
    try {
      const result = await NodeListAllService(); // Usar el nuevo servicio sin permisos
      if (result.success) {
        // Filtrar solo nodos activos
        const activeNodes = result.payload.filter((node) => node.active === true);
        setNodesList(activeNodes);
      } else {
        handleAlert("error", result.message);
      }
    } catch (error) {
      handleAlert("error", "Error al obtener los nodos");
    }
  };

  const requestUsersList = async () => {
    try {
      const result = await UsersForFiltersService();
      if (result.success) {
        setUsersList(result.payload);
      } else {
        handleAlert("error", result.message);
      }
    } catch (error) {
      handleAlert("error", "Error al obtener la lista de usuarios");
    }
  };

  const handlePageChange = (event, value) => {
    setCurrentPage(value);
  };

  const pageIndexAndPageSize = async (pageSize) => {
    setPaginaSize(pageSize);
    requestActivitiesList((currentPage - 1) * pageSize + 1);
  };

  const handleActivityCreate = (event) => {
    event.preventDefault();
    resetFieldValid();
    setNewData({
      title: "",
      fecha: "",
      timeStart: "",
      timeEnd: "",
      description: "",
      keywords: "",
      evidence_formats: "",
      is_certifiable: null,
      categories: "",
      node_id: "",
    });
    requestNodesList(); // Asegurar que la lista esté actualizada
    setOpenCreate(true);
  };

  const submitActivityCreate = async (e) => {
    e.preventDefault();
    const hasErrors = hasInvalidFields(isFieldValid);

    if (hasErrors) {
      handleAlert("fail", "Hay al menos un error en los campos ingresados");
      return;
    }

    setLoading(true);

    try {
      const startDateTime = `${newData.fecha}T${newData.timeStart}:00`;
      const endDateTime = `${newData.fecha}T${newData.timeEnd}:00`;
      const typeViewActivity = valueTab === 0 ? "agenda" : "table";

      // Escapar campos sensibles para evitar inyección de HTML/JS
      const escapeHtml = (unsafe) => {
        if (unsafe === null || unsafe === undefined) return unsafe;
        return String(unsafe)
          .replace(/&/g, "&amp;")
          .replace(/</g, "&lt;")
          .replace(/>/g, "&gt;")
          .replace(/"/g, "&quot;")
          .replace(/'/g, "&apos;");
      };

      const dataToSend = {
        ...newData,
        // Escapar solo los campos de texto que puedan contener HTML peligroso
        title: escapeHtml(newData.title),
        description: escapeHtml(newData.description),
        keywords: escapeHtml(newData.keywords),
        fecha: startDateTime,
        fecha_fin: endDateTime,
      };

      const result = await ActivitiesCreateService(dataToSend);

      if (result.success) {
        handleAlert("success", "Actividad creada con éxito.");
        await requestActivitiesList(currentPage, paginaSize, typeViewActivity);
        closeActivityCreate();
      } else {
        handleAlert("fail", result.message || "Error al crear la actividad.");
      }
    } catch (error) {
      console.error("Error durante la creación de actividad:", error);
      handleAlert("fail", "Ocurrió un error al procesar la solicitud.");
    } finally {
      setLoading(false);
    }
  };

  const closeActivityCreate = () => setOpenCreate(false);

  // Función para detectar cambios en los datos de edición
  const detectChanges = (currentData, originalData) => {
    // Comparar todos los campos excepto subcategories
    const fieldsToCompare = ['title', 'fecha', 'timeStart', 'timeEnd', 'description', 'keywords', 'evidence_formats', 'is_certifiable', 'node_id'];

    for (const field of fieldsToCompare) {
      if (currentData[field] !== originalData[field]) {
        return true;
      }
    }

    // Comparar subcategorías (arrays)
    const currentSubcategories = currentData.subcategories || [];
    const originalSubcategories = originalData.subcategories || [];

    if (currentSubcategories.length !== originalSubcategories.length) {
      return true;
    }

    // Ordenar y comparar arrays
    const sortedCurrent = [...currentSubcategories].sort();
    const sortedOriginal = [...originalSubcategories].sort();

    for (let i = 0; i < sortedCurrent.length; i++) {
      if (sortedCurrent[i] !== sortedOriginal[i]) {
        return true;
      }
    }

    return false;
  };

  // Funciones para manejo de edición
  const handleActivityEdit = async (activity) => {
    try {
      setLoading(true);

      // Obtener datos completos de la actividad
      const result = await ActivityGetService(activity.id);

      if (result.success) {
        const activityData = result.payload;

        // Separar fecha y hora
        const fechaInicio = new Date(activityData.fecha);
        const fechaFin = new Date(activityData.fecha_fin);

        const fecha = fechaInicio.toISOString().split('T')[0];
        const timeStart = fechaInicio.toTimeString().slice(0, 5);
        const timeEnd = fechaFin.toTimeString().slice(0, 5);

        const dataToSave = {
          title: activityData.title || "",
          fecha: fecha,
          timeStart: timeStart,
          timeEnd: timeEnd,
          description: activityData.description || "",
          keywords: activityData.keywords || "",
          evidence_formats: activityData.evidence_formats || "",
          is_certifiable: activityData.is_certifiable,
          node_id: activityData.node_id || "",
          subcategories: activityData.subcategories || [],
        };

        // Configurar datos para edición
        setEditData(dataToSave);

        // Guardar datos originales para comparación
        setOriginalEditData({ ...dataToSave });

        // Configurar subcategorías seleccionadas
        setSelectedSubcategoriesEdit(activityData.subcategories || []);

        setEditingActivity(activityData);
        resetFieldValidEdit();
        setHasChanges(false); // Inicializar sin cambios

        // Cargar datos necesarios antes de abrir el modal
        await Promise.all([
          requestNodesList(),
          requestSubCategoriesList()
        ]);

        setOpenEdit(true);
      } else {
        handleAlert("error", result.message || "Error al obtener los datos de la actividad");
      }
    } catch (error) {
      console.error("Error al obtener actividad:", error);
      handleAlert("error", "Error al obtener los datos de la actividad");
    } finally {
      setLoading(false);
    }
  };

  const submitActivityEdit = async (e) => {
    e.preventDefault();
    const hasErrors = hasInvalidFields(isFieldValidEdit);

    if (hasErrors) {
      handleAlert("fail", "Hay al menos un error en los campos ingresados");
      return;
    }

    setLoading(true);
    setIsSubmittingEdit(true);

    try {
      const startDateTime = `${editData.fecha}T${editData.timeStart}:00`;
      const endDateTime = `${editData.fecha}T${editData.timeEnd}:00`;
      const typeViewActivity = valueTab === 0 ? "agenda" : "table";

      const dataToSend = {
        ...editData,
        fecha: startDateTime,
        fecha_fin: endDateTime,
      };

      const result = await ActivityUpdateService(editingActivity.id, dataToSend);

      if (result.success) {
        handleAlert("success", "Actividad actualizada con éxito.");
        closeActivityEdit();
        // Recargar la lista después de cerrar el modal para evitar conflictos
        setTimeout(async () => {
          await requestActivitiesList(currentPage, paginaSize, typeViewActivity);
        }, 100);
      } else {
        handleAlert("fail", result.message || "Error al actualizar la actividad.");
      }
    } catch (error) {
      console.error("Error durante la actualización de actividad:", error);
      handleAlert("fail", "Ocurrió un error al procesar la solicitud.");
    } finally {
      setLoading(false);
      setIsSubmittingEdit(false);
    }
  };

  const closeActivityEdit = () => {
    setOpenEdit(false);
    setEditingActivity(null);
    const cleanData = {
      title: "",
      timeStart: "",
      timeEnd: "",
      fecha: "",
      description: "",
      keywords: "",
      evidence_formats: "",
      is_certifiable: null,
      categories: "",
      node_id: "",
      subcategories: [],
    };
    setEditData(cleanData);
    setOriginalEditData(cleanData);
    setSelectedSubcategoriesEdit([]);
    setHasChanges(false);
    setIsSubmittingEdit(false);
    resetFieldValidEdit();
  };

  const validateTimeRange = (timeStart, timeEnd) => {
    if (!timeStart || !timeEnd) return true;
    return timeStart < timeEnd;
  };

  const handleFieldChange = (name, value, event) => {
    if (name === "keywords" && event) {
      const input = event.target;
      const cursorPosition = input.selectionStart;
      const newValue = value.toUpperCase();

      setNewData((prevData) => ({
        ...prevData,
        [name]: newValue,
      }));
      handleChangeValid(name, newValue);

      // Restaurar posición del cursor
      Promise.resolve().then(() => {
        input.setSelectionRange(cursorPosition, cursorPosition);
      });
    } else {
      const newValue = name === "keywords" ? value.toUpperCase() : value;
      setNewData((prevData) => ({
        ...prevData,
        [name]: newValue,
      }));
      handleChangeValid(name, newValue);

      if (name === "timeEnd") {
        const isValid = validateTimeRange(newData.timeStart, newValue);
        setIsFieldValid((prev) => ({
          ...prev,
          timeEnd: isValid,
        }));
      } else if (name === "timeStart") {
        const isValid = validateTimeRange(newValue, newData.timeEnd);
        setIsFieldValid((prev) => ({
          ...prev,
          timeStart: isValid,
        }));
      }
    }
  };

  // Manejar cambios de campo para edición
  const handleFieldChangeEdit = (name, value, event) => {
    if (name === "keywords" && event) {
      const input = event.target;
      const cursorPosition = input.selectionStart;
      const newValue = value.toUpperCase();

      const updatedData = {
        ...editData,
        [name]: newValue,
      };

      setEditData(updatedData);

      // Detectar cambios comparando con datos originales
      const hasDataChanges = detectChanges(updatedData, originalEditData);
      setHasChanges(hasDataChanges);

      handleChangeValidEdit(name, newValue);

      // Restaurar posición del cursor
      Promise.resolve().then(() => {
        input.setSelectionRange(cursorPosition, cursorPosition);
      });
    } else {
      const newValue = name === "keywords" ? value.toUpperCase() : value;

      const updatedData = {
        ...editData,
        [name]: newValue,
      };

      setEditData(updatedData);

      // Para subcategorías, también actualizar el estado separado
      if (name === "subcategories") {
        setSelectedSubcategoriesEdit(value);
      }

      // Detectar cambios comparando con datos originales
      const hasDataChanges = detectChanges(updatedData, originalEditData);
      setHasChanges(hasDataChanges);

      handleChangeValidEdit(name, newValue);

      if (name === "timeEnd") {
        const isValid = validateTimeRange(editData.timeStart, newValue);
        setIsFieldValidEdit((prev) => ({
          ...prev,
          timeEnd: isValid,
        }));
      } else if (name === "timeStart") {
        const isValid = validateTimeRange(newValue, editData.timeEnd);
        setIsFieldValidEdit((prev) => ({
          ...prev,
          timeStart: isValid,
        }));
      }
    }
  };

  // Maneja las alertas de exito fallo
  const handleAlert = (typeAlert, message) => {
    setTypeAlert(typeAlert);
    setMessage(message);
    setIsAlert(true);
  };

  const requestGendersList = async () => {
    try {
      const result = await GendersListService();
      if (result.success) {
        setGendersList(result.payload);
      }
    } catch (error) {
      console.error("Error al obtener géneros:", error);
    }
  };

  const requestSpecialProtectionGroupsList = async () => {
    try {
      const result = await SpecialProtectionGroupsListService();
      if (result.success) {
        setSpecialProtectionGroupsList(result.payload);
      }
    } catch (error) {
      console.error("Error al obtener Poblaciones Vulnerables:", error);
    }
  };

  useEffect(() => {
    const loadInitialData = async () => {
      if (isFirstLoad) {
        setInitialLoading(true);
        try {
          // Primero cargar nodos, subcategorías, géneros, grupos de protección y usuarios
          await Promise.all([requestSubCategoriesList(), requestNodesList(), requestGendersList(), requestSpecialProtectionGroupsList(), requestUsersList()]);

          // Pequeña pausa para asegurar que los estados se actualicen
          await new Promise(resolve => setTimeout(resolve, 100));

          // Luego cargar actividades (ya con nodos disponibles)
          const typeViewActivity = valueTab === 0 ? "agenda" : "table";
          await requestActivitiesList(currentPage, 10, typeViewActivity);
        } catch (error) {
          console.error("Error loading initial data:", error);
          handleAlert("error", "Error al cargar los datos iniciales");
        } finally {
          // Otra pequeña pausa antes de quitar el loading para evitar flickering
          await new Promise(resolve => setTimeout(resolve, 200));
          setInitialLoading(false);
          setIsFirstLoad(false);
        }
      } else {
        // Solo cargar actividades si no es la primera carga
        const typeViewActivity = valueTab === 0 ? "agenda" : "table";
        await requestActivitiesList(currentPage, 10, typeViewActivity);
      }
    };
    loadInitialData();
  }, [currentPage]);

  // Estado de las validaciones
  const [isFieldValid, setIsFieldValid] = useState({
    title: true,
    fecha: true,
    timeStart: true,
    timeEnd: true,
    description: true,
    keywords: true,
    evidence_formats: true,
    is_certifiable: true,
    subcategories: true,
    node_id: true,
  });

  // Estado de validaciones para edición
  const [isFieldValidEdit, setIsFieldValidEdit] = useState({
    title: true,
    fecha: true,
    timeStart: true,
    timeEnd: true,
    description: true,
    keywords: true,
    evidence_formats: true,
    is_certifiable: true,
    subcategories: true,
    node_id: true,
  });

  // Función para verificar si algún campo no es válido
  const hasInvalidFields = (fields) => {
    return Object.values(fields).some((value) => value === false);
  };

  // Setea los valores de las validaciones
  const resetFieldValid = () => {
    setIsFieldValid({
      title: true,
      timeStart: true,
      timeEnd: true,
      fecha: true,
      description: true,
      keywords: true,
      evidence_formats: true,
      is_certifiable: true,
      subcategories: true,
      node_id: true,
    });
  };

  // Resetea validaciones para edición
  const resetFieldValidEdit = () => {
    setIsFieldValidEdit({
      title: true,
      timeStart: true,
      timeEnd: true,
      fecha: true,
      description: true,
      keywords: true,
      evidence_formats: true,
      is_certifiable: true,
      subcategories: true,
      node_id: true,
    });
  };

  // Expresiones regulares para diferentes tipos de campos
  const validationPatterns = {
    // Allow any character but require at least one non-space character for title and description
    title: /^(?=.*\S)[\s\S]*$/, // At least one non-space character
    fecha: /^\d{4}-(0[1-9]|1[0-2])-(0[1-9]|[12][0-9]|3[01])$/, // Solo permite letras y espacios
    description: /^(?=.*\S)[\s\S]*$/, // At least one non-space character
    timeStart: /^([0-1]?[0-9]|2[0-3]):[0-5][0-9]$/,
    timeEnd: /^([0-1]?[0-9]|2[0-3]):[0-5][0-9]$/,
    keywords: /^[a-zA-ZÀ-ÿ\s\u00f1\u00d1]+$/, // Solo permite letras, comas y espacios
    evidence_formats: /^[\s\S]*\S[\s\S]*$/, // Al menos un carácter que no sea un espacio
    is_certifiable: /^[\s\S]*\S[\s\S]*$/, // Al menos un carácter que no sea un espacio
    node_id: /^[\s\S]*\S[\s\S]*$/, // Al menos un carácter que no sea un espacio
    // categories: /^[\s\S]*\S[\s\S]*$/, // Al menos un carácter que no sea un espacio
  };

  // Compara el valor del input con la expresion regular requerida
  const validateField = (value, pattern) => {
    return pattern.test(value);
  };

  // Comprueba la validez del campo y luego establece la validez en el estado
  const handleChangeValid = (fieldName, value) => {
    // const isFieldValid = validateField(value.trim(), validationPatterns[fieldName]);

    let isValid = true;

    if (fieldName === "subcategories") {
      // Verificar que se haya seleccionado al menos una opción
      isValid = Array.isArray(value) && value.length > 0;
    } else if (fieldName === "node_id") {
      // Verificar que se haya seleccionado un nodo
      isValid = value && value.trim() !== "";
    } else {
      // Otras validaciones para otros campos
      if (fieldName === "is_certifiable") {
        isValid = validateField(value, validationPatterns[fieldName]);
      } else {
        isValid = validateField(value.trim(), validationPatterns[fieldName]);
      }
    }

    setIsFieldValid((prevValidity) => ({
      ...prevValidity,
      [fieldName]: isValid,
    }));
  };

  // Validación para edición
  const handleChangeValidEdit = (fieldName, value) => {
    let isValid = true;

    if (fieldName === "subcategories") {
      // Verificar que se haya seleccionado al menos una opción
      isValid = Array.isArray(value) && value.length > 0;
    } else if (fieldName === "node_id") {
      // Verificar que se haya seleccionado un nodo
      isValid = value && value.trim() !== "";
    } else {
      // Otras validaciones para otros campos
      if (fieldName === "is_certifiable") {
        isValid = validateField(value, validationPatterns[fieldName]);
      } else {
        isValid = validateField(value.trim(), validationPatterns[fieldName]);
      }
    }

    setIsFieldValidEdit((prevValidity) => ({
      ...prevValidity,
      [fieldName]: isValid,
    }));
  };

  // Manejo del cambio de pestaña
  const [valueTab, setValueTab] = useState(0);

  // Cambiar de pestaña
  const handleChangeTab = async (event, newValue) => {
    setValueTab(newValue);
    setLoading(true);
    try {
      if (newValue === 0) {
        // Asegurar que los nodos estén cargados antes de mostrar el calendario
        if (nodesList.length === 0) {
          await requestNodesList();
        }
        await requestActivitiesList(1, 10, "agenda");
      } else {
        await requestActivitiesList(currentPage, 10, "table");
      }
    } catch (error) {
      handleAlert("error", "Error al cambiar la vista");
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      {loading && <Spinner />}
      {alert.visible && <MDAlert type={alert.type} message={alert.message} />}
      <MDAlert isAlert={isAlert} setIsAlert={setIsAlert} typeAlert={typeAlert} message={message} />
      <FilterController
        filterConfig={filterConfig}
        dataTable={dataTable}
        ref={filterControllerRef}
        setTotalData={setTotalData}
        setEntriesEnd={setEntriesEnd}
        setEntriesStart={setEntriesStart}
        currentPage={currentPage}
        setCurrentPage={setCurrentPage}
        setTotalPages={setTotalPages}
        setListData={setActivitiesList}
        handleAlert={handleAlert}
        viewListActivity={valueTab}
        gendersList={gendersList}
        specialProtectionGroupsList={specialProtectionGroupsList}
        nodesList={nodesList}
        usersList={usersList}></FilterController>
      <ActivitiesList
        handleActivitiesList={handleActivitiesList}
        pageIndexAndPageSize={pageIndexAndPageSize}
        entriesStart={entriesStart}
        entriesEnd={entriesEnd}
        totalData={totalData}
        totalPages={totalPages}
        currentPage={currentPage}
        handlePageChange={handlePageChange}
        handleActivitiesCreate={handleActivityCreate}
        handleActivitiesEdit={handleActivityEdit}
        callHandleClickSubmit={callHandleClickSubmit}
        valueTab={valueTab}
        handleChangeTab={handleChangeTab}
        setValueTab={setValueTab}
        initialLoading={initialLoading}
        nodesList={nodesList}
      />
      <ActivitiesCreate
        open={openCreate}
        handleClose={closeActivityCreate}
        isDisabled={isDisabled}
        getFieldValue={(field) => (newData[field] !== undefined ? newData[field] : "")}
        handleFieldChange={handleFieldChange}
        handleSubmit={submitActivityCreate}
        listSubCategories={subCategoriesList}
        listNodes={nodesList}
        isFieldValid={isFieldValid}
      />
      <ActivitiesEdit
        open={openEdit}
        handleClose={closeActivityEdit}
        isDisabled={isDisabled}
        getFieldValue={(field) => {
          if (field === "subcategories") {
            return editData[field] || [];
          }
          return editData[field] !== undefined ? editData[field] : "";
        }}
        handleFieldChange={handleFieldChangeEdit}
        handleSubmit={submitActivityEdit}
        listSubCategories={subCategoriesList}
        listNodes={nodesList}
        isFieldValid={isFieldValidEdit}
        selectedSubcategories={selectedSubcategoriesEdit}
        setSelectedSubcategories={setSelectedSubcategoriesEdit}
        hasChanges={hasChanges}
        isSubmitting={isSubmittingEdit}
      />
    </>
  );
}
